import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  coverage({ months, ignoreDyno, productFilter }) {
    return apiClient.get('/inventory/coverage', {
      params: {
        months,
        ignore_dyno: ignoreDyno ? 1 : 0,
        product_filter: productFilter
      }
    })
  }
}
